module.exports = __webpack_public_path__ + "img/7b904742-4afd-4839-8f3f-9401868c3313.3c4d68e4.png";